function setupBlogMotion(root = document) {
  const site = root.querySelector('.blog-site');
  if (!site) return () => {};

  const targets = site.querySelectorAll([
    '.blog-hero-grid > *',
    '.blog-archive-head',
    '.blog-category-heading',
    '.blog-card',
    '.blog-article-hero-grid > *',
    '.blog-toc',
    '.blog-quick-answer',
    '.blog-prose > section',
    '.blog-product-link',
    '.blog-more-head',
  ].join(','));
  targets.forEach(target => target.classList.add('blog-reveal'));
  const showAll = () => targets.forEach(target => target.classList.add('is-visible'));
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  if (!targets.length || reduceMotion || !('IntersectionObserver' in window)) {
    showAll();
    return () => {};
  }

  site.classList.add('blog-motion-ready');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });

  targets.forEach(target => observer.observe(target));
  return () => {
    observer.disconnect();
    site.classList.remove('blog-motion-ready');
  };
}

module.exports = setupBlogMotion;
